import { useState, useEffect, useCallback } from "react";
import { API, graphqlOperation } from "aws-amplify";
import "react-quill/dist/quill.snow.css";
import * as queries from "../../graphql/queries";
import { useNavigate } from "react-router-dom";
import "./PrivacyPolicy.css";
import { Table } from "../Table/Table";
import { getPolicyType } from "./PrivacyPolicType";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { Container } from "react-bootstrap";
import { Flex, Heading } from "@aws-amplify/ui-react";
import { Spinner } from "../_shared/Loader";
import { PolicyStatusPill } from "../_shared/StatusPill";

export const PrivacyPolicy = () => {
  const [filteredPolicyList, setFilteredPolicyList] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const filterPolicy = useCallback((policies) => {
    const filteredPolicies = policies?.data?.getPolicy?.map((policy) => {
      return {
        ...policy,
        Active: <PolicyStatusPill active={policy.isActive} />,
      };
    });
    setFilteredPolicyList(filteredPolicies);
  }, []);

  const fetchPolicies = useCallback(async () => {
    setLoading(true);
    try {
      const policies = (await API.graphql(
        graphqlOperation(queries.getPolicy)
      )) as GraphQLResult<getPolicyType>;
      filterPolicy(policies);
    } catch (e) {
      console.error("Error fetching policies:", e);
    } finally {
      setLoading(false);
    }
  }, [filterPolicy]);

  const selectPolicy = (row) => {
    navigate(`/policy/${row.id}`);
  };

  useEffect(() => {
    fetchPolicies();
  }, [fetchPolicies]); // Empty dependency array ensures this runs once after mount

  return (
    <Container style={{ padding: 25 }} fluid>
      <Flex direction="column" gap="1.5rem">
        <Heading level={2} className="screen-title">
          Privacy Policies
        </Heading>
        <div style={{ display: "flex", flex: 1 }}>
          {loading && <Spinner loading={loading} />}
          <Table
            tableRows={filteredPolicyList}
            excludeKeys={["id", "isActive"]}
            pagination={10}
            handleSelect={selectPolicy}
          />
        </div>
      </Flex>
    </Container>
  );
};
